import "bootstrap/dist/js/bootstrap.bundle.min.js";
import Carousel from "../../Carousel";
import Portfolio from "../../Portfolio";
import RecoverySection from "../../Recovery";
import { counters } from "../../Constants/Counters";

const KhushiFerao = () => {
  const bannersItems = [
    {
      img: "/assets/img/m-khusi/s1.png",
    },
  ];

  const portfolioImage = [
    {
      img: "/assets/img/m-khusi/G1.jpg",
      title: "A Gathering of Grace",
      description:
        "Under the open sky and hopeful eyes, we shared stories, laughter, and lessons. What seemed like a simple gathering turned into a beautiful exchange of wisdom, inspiration, and unspoken",
    },
    {
      img: "/assets/img/m-khusi/G2.jpg",
      title: "Tiny Cake, Big Happiness",
      description:
        "A birthday celebrated with an entire village—it’s more than cake. It’s the moment a child feels special, loved, and remembered. Khushi Fehrao brings such joy to places where birthdays are dreams waiting to be lived.",
    },
    {
      img: "/assets/img/m-khusi/G3.jpg",
      title: "A Celebration Under the Trees",
      description:
        "Joy knows no walls! On this day, we gathered beneath the open sky to celebrate a birthday—with balloons, music, and cake—spreading smiles among children who rarely experience such colorful moments.",
    },
    {
      img: "/assets/img/m-khusi/G4.jpg",
      title: "Walking Toward Dreams",
      description:
        "Two young girls, bright and hopeful, walk hand-in-hand with umbrellas —a symbol of the smiles we helped create through educational support and emotional care. Every step forward is a step of happiness.",
    },
    {
      img: "/assets/img/m-khusi/G5.jpg",
      title:
        "Colors of Culture, Shades of Joy",
      description:
        "Our dedicated volunteers are on a mission to serve essential nutrients to underprivileged children. This image captures the joy and gratitude of young faces as they receive nutritious meals designed to support their growth and development",
    },
    {
      img: "/assets/img/m-khusi/G6.jpg",
      title: "Monsoons of Memories",
      description:
        "Rain couldn’t stop the joy! With little umbrellas and big smiles, children celebrated a happy event with music and love. Their giggles echoed louder than thunder—a moment of pure togetherness.",
    },
    {
      img: "/assets/img/m-khusi/G7.jpg",
      title: "Gift of Dignity",
      description:
        "In their eyes shone excitement as we handed over clean, beautiful clothes—reminding them they are seen, valued, and celebrated. Giving doesn’t just provide, it uplifts.",
    },
    {
      img: "/assets/img/m-khusi/G8.jpg",
      title: "Smiles That Bloom in Villages",
      description:
        "From distant corners, they came dressed in bright clothes and brighter smiles. We stood together, united by celebration, love, and happiness—sharing cakes, stories, and the warmth of community.",
    },
    {
      img: "/assets/img/m-khusi/G9.jpg",
      title:
        "A Birthday, A Blessing",
      description:
        "A cake was cut, candles lit, and laughter shared. This birthday wasn’t just a celebration—it was a gift of love and presence, lighting up a senior’s life in a home where joy had been silent.",
    },
  ];


  return (
    <main className="main">
      <Carousel bannersItems={bannersItems} />
      <RecoverySection
        counters={[counters[2]]}
        logoSrc="/assets/img/mlogo/mlogo.png"
        backgroundImage="/assets/img/m-blood/m-recovery.jpg"
        title="FROM ASPIRATION TO REALITY"
        content="Your content goes here."
      />

      <Portfolio
        portfolioHeader="KHUSHI FEHRAO: CELEBRATING JOY BY SHARING SMILES"
        description="Our photo gallery is a visual representation of our journey and the
        impactful moments we've shared as a community. Each image tells a story,
        capturing the essence of our initiatives, the smiles of those we've helped,
        and the spirit of togetherness that defines us. From community events to
        relief efforts, these photographs reflect our commitment to making a
        difference and the bonds we've forged along the way. We invite you to
        explore our gallery and witness the transformation that has taken place
        since our inception in 2017."
        portfolioImage={portfolioImage}
        contact
      />

    </main>
  );
};

export default KhushiFerao;
